import { Box, BoxProps } from "@chakra-ui/react";
import { memo, PropsWithChildren } from "react";

interface Props extends BoxProps {
  width: number; // %
  height: number; // %
  top: number; // %
  left: number; // %
}

const ComponentFrameContainer = (props: PropsWithChildren<Props>) => {
  const { width, height, top, left, children, ...boxProps } = props;

  return (
    <Box
      position="absolute"
      width={`${width}%`}
      height={`${height}%`}
      top={`${top}%`}
      left={`${left}%`}
      {...boxProps}
    >
      {children}
    </Box>
  );
};

export default memo(ComponentFrameContainer);
